module.exports = "/assets/data/9b925d83bf4bc66ce2797db5ed61c7aa-IG10.data.json";